<template>
  <div>
    <base-header class=" bg-gradient-success">
      <b-form @submit.prevent="submitForm">
         
          <b-row v-for="(chofer, index) in form.choferes" :key="index" class="mb-2 chofer-container">
            <b-col md="3">
              <b-form-group :label="`${$t('nombre_chofer')}`" :label-for="'nombre-' + index">
                <b-form-input v-model="chofer.nombre" :id="'nombre-' + index" required
                  :placeholder="$t('ingrese_nombre')"></b-form-input>
              </b-form-group>
            </b-col>
            <b-col md="3">
              <b-form-group :label="`${$t('apellido_chofer')}`" :label-for="'apellido-' + index">
                <b-form-input v-model="chofer.apellido" :id="'apellido-' + index" type="text" required
                  :placeholder="$t('ingrese_nombre')"></b-form-input>
              </b-form-group>
            </b-col>
            <b-col md="3">
              <b-form-group :label="`${$t('rut_chofer')}`" :label-for="'rut-' + index">
                <b-form-input v-model="chofer.rut" :id="'rut-' + index" type="text" required
                  :placeholder="$t('ingrese_rut')"></b-form-input>
              </b-form-group>
            </b-col>
          </b-row>

        <b-button variant="danger" class="ml-2" @click="$emit('close')">
          <i class="fas fa-arrow-left"></i> {{$t('cancelar')}}
        </b-button>
        <b-button type="submit" v-if="form.choferes.length > 0" variant="primary">
          {{$t('guardar')}}
        </b-button>
      </b-form>
    </base-header>
  </div>
</template>

<script>
import choferService from '@/api/choferService';

export default {
  data() {
    return {
      form: {
        choferes: [],
      }
    };
  },
  async beforeMount() {  
    this.form.choferes.push({
        nombre: '',
        apellido: '',
        rut: '',
      });
  },
  methods: {
    async submitForm() {
      try {
        const response = await choferService.create(this.form);
        if (!response) throw new Error('Ocurrio un error al crear el ingreso, intente nuevamente.');
        Swal.fire({
          title: "Creado correctamente",
          icon: "success",
          showConfirmButton: false,
          timer: 2000,
          background: '#f8f9fa',
          customClass: {
            title: 'swal-title',
            icon: 'swal-icon',
          },
        });
        this.$emit('created');
        this.$emit('close');

      } catch (error) {
        Swal.fire({
          icon: "error",
          title: "Oops...",
          text: error.message
        });
      }
    }
  }
};
</script>

<style>
.el-table.table-dark {
  background-color: #4d4c4c;
  color: #f8f9fe;
}

.el-table.table-dark th,
.el-table.table-dark tr {
  background-color: #4d4c4c;
}

.el-table.table-dark td,
.el-table.table-dark th.is-leaf {
  border-bottom: none;
}
.chofer-container {
  background-color: #f8fafc;
    padding: 10px 5px 1px;
    border-radius: 10px;
}
</style>
